import React from 'react';
import _ from 'lodash';
import {observer} from 'mobx-react';
import {t, withState} from 'shared/core';
import {formatTimeOffAmount} from 'main/tools';
import {FormattedMessage} from 'react-intl';
import {Label} from 'shared/components';
import TypePolicyModalState from '../state/TypePolicyModalState';

const DetailRow = observer(({title, value, className = 'jumbo'}) => {
  return (
    <div className='clearfix my2'>
      <div className='col col-6'>
        {title}
      </div>
      <div className={`col col-6 ${className}`}>
        <Label model={value} />
      </div>
    </div>
  );
});

const AnniversaryBonus = observer(({anniversary, index, unit}) => {
  return (
    <div className={`${index === 0 ? '' : 'mt1'}`}>
      <FormattedMessage
        id={`employees.profile.time_off.EXTRA_AMOUNT_PER_ANNIVERSARY.${unit}`}
        values={{
          amount: anniversary.rateAdjustment,
          years: anniversary.anniversary,
        }}
      />
    </div>
  );
});

const BalanceAdjustmentPolicy = observer(({typePolicy, policy, type, employee}) => {
  const {balanceAdjustmentPolicy} = typePolicy;

  return (
    <div>
      <div className='mb1'>
        <FormattedMessage id={balanceAdjustmentPolicy.localizationTitle}/>
      </div>
      <div>
        <FormattedMessage
          id={balanceAdjustmentPolicy.localizationDetail}
          values={{
            typeName: <span className='black medium'>{type.name}</span>,
            date: <span className='black medium'>{typePolicy.yearStartForPolicyHolder(policy, employee)}</span>,
            amount: <span className='black medium'>{formatTimeOffAmount(balanceAdjustmentPolicy.parameter, type.unit)}</span>,
            limit: <span className='black medium'>{t('employees.profile.time_off.days', {days: balanceAdjustmentPolicy.limitDays})}</span>,
            unit: t(`time_off.units.${type.unit}`)
          }}/>
      </div>
    </div>
  );
});

const PolicySummaryModalContent = observer(({uiState, policySummaryAccount}) => {
  const {typePolicy, policy, employee} = uiState;
  const {timeOffType} = policySummaryAccount;

  return (
    <div>
      <div className='h2 medium'>
        <FormattedMessage id='employees.profile.time_off.POLICY' values={{policy: timeOffType.name}}/>
      </div>
      <DetailRow
        title={t('employees.profile.time_off.Total Accrual Rate Per Year')}
        value={formatTimeOffAmount(typePolicy.totalAccrualPerYear, timeOffType.unit)}/>
      <DetailRow
        className='black medium'
        title={t('employees.profile.time_off.Accrual Rate')}
        value={`${formatTimeOffAmount(typePolicy.accrualRate, timeOffType.unit)} ${_.toLower(t(`models.time_off.type_policy.accrual_frequency.${typePolicy.accrualFrequency}`))}`
      }/>
      <hr/>
      <div className='h3 medium mb2'>
        <FormattedMessage id='employees.profile.time_off.Additional Details'/>
      </div>
      <DetailRow
        title={t('employees.profile.time_off.Accrual Start Date')}
        value={typePolicy.yearStartForPolicyHolder(policy, employee)}/>
      <DetailRow
        title={t('employees.profile.time_off.Accrual Frequency')}
        value={t(`models.time_off.type_policy.accrual_frequency.${typePolicy.accrualFrequency}`)}/>
      <DetailRow
        title={t('employees.profile.time_off.Base Accrual Rate Per Year')}
        value={formatTimeOffAmount(typePolicy.baseAccrualRate, timeOffType.unit)}/>
      <DetailRow
        title={t('employees.profile.time_off.Accrual Bonuses')}
        value={typePolicy.sortedAnniversaryBonuses.map((a, index) => <AnniversaryBonus index={index} key={a.id} anniversary={a} unit={timeOffType.unit}/>)}/>
      <DetailRow
        title={t('employees.profile.time_off.Waiting Period')}
        value={t('employees.profile.time_off.DAYS', {days: typePolicy.waitPeriod})}/>
      <DetailRow
        title={t('employees.profile.time_off.Prorated In First Year')}
        value={t(`employees.profile.time_off.${typePolicy.prorationEnabled}`)}/>
      <DetailRow
        title={t('employees.profile.time_off.Carryover Rules')}
        value={
          <BalanceAdjustmentPolicy
            typePolicy={typePolicy}
            policy={policy}
            type={timeOffType}
            employee={employee}
          />
        }/>
    </div>
  );
});

export default withState(PolicySummaryModalContent, TypePolicyModalState);
